/**
 * Product purchase: multi-variant tier selector → CartStore.addItem(variantId, 1, { _tier_units })
 * Copy (säck vs m³) från data-attribut på [data-product-purchase] (styrs av custom.purchase_unit i Liquid).
 */
(function () {
  'use strict';

  function formatSek(cents) {
    var n = Math.round(Number(cents) / 100);
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }

  function readCopy(root) {
    return {
      mode: root.getAttribute('data-purchase-mode') || 'sack',
      unitOne: root.getAttribute('data-unit-one') || 'säck',
      unitMany: root.getAttribute('data-unit-many') || 'säckar',
      perSuffix: root.getAttribute('data-per-suffix') || 'st',
    };
  }

  function readCampaign(root, copy) {
    var percent = parseInt(root.getAttribute('data-campaign-percent'), 10);
    var minQty = parseInt(root.getAttribute('data-campaign-min-qty'), 10);
    return {
      active: root.getAttribute('data-campaign-active') === 'true' && copy.mode === 'sack',
      percent: Number.isFinite(percent) && percent > 0 ? percent : 15,
      minQty: Number.isFinite(minQty) && minQty > 0 ? minQty : 2,
      code: root.getAttribute('data-campaign-code') || 'VED15',
    };
  }

  function calculateCampaignSavings(card, campaign) {
    var fullPrice = Number.isFinite(card.linear) && card.linear > 0 ? card.linear : card.price;
    var qtySaving = Math.max(fullPrice - card.price, 0);
    var qtySavingPercent = fullPrice > 0 ? Math.round((qtySaving / fullPrice) * 100) : 0;
    var campaignActive = campaign.active && card.qty >= campaign.minQty;
    var campaignSaving = campaignActive ? Math.round((card.price * campaign.percent) / 100) : 0;
    var finalTotal = Math.max(card.price - campaignSaving, 0);
    var finalPricePerUnit = card.qty > 0 ? Math.round(finalTotal / card.qty) : finalTotal;
    var totalSaving = Math.max(fullPrice - finalTotal, 0);
    var totalSavingPercent = fullPrice > 0 ? Math.round((totalSaving / fullPrice) * 100) : 0;

    return {
      fullPrice: fullPrice,
      qtySaving: qtySaving,
      qtySavingPercent: qtySavingPercent,
      campaignActive: campaignActive,
      campaignSaving: campaignSaving,
      finalTotal: finalTotal,
      finalPricePerUnit: finalPricePerUnit,
      totalSaving: totalSaving,
      totalSavingPercent: totalSavingPercent,
    };
  }

  function parseCards(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.qty-card:not(.qty-card--disabled)')).map(function (el) {
      return {
        el: el,
        id: parseInt(el.getAttribute('data-variant-id'), 10),
        price: parseInt(el.getAttribute('data-price'), 10),
        qty: parseInt(el.getAttribute('data-qty'), 10),
        linear: parseInt(el.getAttribute('data-linear'), 10),
        savings: parseInt(el.getAttribute('data-savings'), 10),
        savingsPct: parseInt(el.getAttribute('data-savings-pct'), 10),
        perSack: parseInt(el.getAttribute('data-per-sack'), 10),
      };
    });
  }

  function findIndex(cards, id) {
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].id === id) return i;
    }
    return 0;
  }

  function updateProductInfoPrice(centsPerSack) {
    var el = document.querySelector('.product-info__price-value');
    if (!el) return;
    el.textContent = formatSek(centsPerSack);
  }

  function updateStickySummary(root, totalText, detailText) {
    var totalEl = root.querySelector('[data-sticky-total]');
    var detailEl = root.querySelector('[data-sticky-detail]');
    if (totalEl) totalEl.textContent = totalText;
    if (detailEl) detailEl.textContent = detailText;
  }

  function updateCampaignSavings(root, card, copy, campaign, savings) {
    var box = root.querySelector('[data-campaign-savings]');
    if (!box) return;

    if (!savings.campaignActive) {
      box.hidden = true;
      return;
    }

    box.hidden = false;

    var totalSaving = box.querySelector('[data-campaign-total-saving]');
    var totalPercent = box.querySelector('[data-campaign-total-percent]');
    var qtyRow = box.querySelector('[data-campaign-qty-row]');
    var qtyLabel = box.querySelector('[data-campaign-qty-label]');
    var qtySaving = box.querySelector('[data-campaign-qty-saving]');
    var qtyPercent = box.querySelector('[data-campaign-qty-percent]');
    var discountSaving = box.querySelector('[data-campaign-discount-saving]');
    var discountPercent = box.querySelector('[data-campaign-discount-percent]');
    var codeLabel = box.querySelector('[data-campaign-code-label]');
    var codeFootnote = box.querySelector('[data-campaign-code-footnote]');

    if (totalSaving) totalSaving.textContent = formatSek(savings.totalSaving);
    if (totalPercent) totalPercent.textContent = '(' + savings.totalSavingPercent + '%)';

    if (qtyRow) {
      qtyRow.hidden = savings.qtySaving <= 0;
    }
    if (qtyLabel) {
      qtyLabel.textContent = '(' + card.qty + ' ' + (card.qty === 1 ? copy.unitOne : copy.unitMany) + ')';
    }
    if (qtySaving) qtySaving.textContent = '-' + formatSek(savings.qtySaving);
    if (qtyPercent) qtyPercent.textContent = '(-' + savings.qtySavingPercent + '%)';
    if (discountSaving) discountSaving.textContent = '-' + formatSek(savings.campaignSaving);
    if (discountPercent) discountPercent.textContent = '(-' + campaign.percent + '%)';
    if (codeLabel) codeLabel.textContent = campaign.code;
    if (codeFootnote) codeFootnote.textContent = campaign.code;
  }

  function setupStickyVisibility(root) {
    var sticky = root.querySelector('[data-purchase-sticky]');
    var addBtn = root.querySelector('[data-purchase-add]');
    if (!sticky || !addBtn) return;

    function setVisible(visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    setVisible(false);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      observer.observe(addBtn);
      return;
    }

    function onScroll() {
      setVisible(addBtn.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function applySelection(root, cards, index) {
    var c = cards[index];
    if (!c) return;

    var copy = readCopy(root);
    var campaign = readCampaign(root, copy);
    var savings = calculateCampaignSavings(c, campaign);
    var maxTierQty = cards.length ? cards[cards.length - 1].qty : 6;
    if (!maxTierQty || maxTierQty < 1) maxTierQty = 6;

    cards.forEach(function (x, i) {
      x.el.classList.toggle('qty-card--selected', i === index);
      x.el.setAttribute('aria-checked', i === index ? 'true' : 'false');
    });

    var amountEl = root.querySelector('[data-price-amount]');
    var origEl = root.querySelector('[data-price-original]');
    var badgeEl = root.querySelector('[data-price-badge]');
    var nudge = root.querySelector('[data-nudge]');
    var nudgeLead = root.querySelector('[data-nudge-lead]');
    var nudgeProg = root.querySelector('[data-nudge-progress]');
    var nudgeSave = root.querySelector('[data-nudge-savings]');
    var sumTotal = root.querySelector('[data-summary-total]');
    var sumDetail = root.querySelector('[data-summary-detail]');
    var sumSave = root.querySelector('[data-summary-save]');
    var sumHint = root.querySelector('[data-summary-hint]');
    var campaignHint = root.querySelector('[data-campaign-hint]');

    var perUnit = savings.finalPricePerUnit;
    var linearPerUnit = c.qty > 0 ? Math.round(savings.fullPrice / c.qty) : perUnit;
    var showDiscount = c.qty > 1 && savings.totalSaving > 0;
    updateProductInfoPrice(perUnit);
    updateCampaignSavings(root, c, copy, campaign, savings);

    if (showDiscount) {
      if (origEl) {
        origEl.hidden = false;
        origEl.textContent = formatSek(linearPerUnit);
      }
      if (amountEl) {
        amountEl.textContent = formatSek(perUnit);
        amountEl.classList.add('price-display__amount--discount');
      }
      if (badgeEl) {
        badgeEl.hidden = false;
        badgeEl.textContent = savings.totalSavingPercent > 0 ? '-' + savings.totalSavingPercent + '%' : '';
      }
    } else {
      if (origEl) {
        origEl.hidden = true;
        origEl.textContent = '';
      }
      if (amountEl) {
        amountEl.textContent = formatSek(perUnit);
        amountEl.classList.remove('price-display__amount--discount');
      }
      if (badgeEl) {
        badgeEl.hidden = true;
        badgeEl.textContent = '';
      }
    }

    if (campaignHint) {
      campaignHint.hidden = savings.campaignActive;
    }

    var totalText = formatSek(savings.finalTotal);
    var detailText = '';
    if (sumTotal) sumTotal.textContent = totalText;
    if (sumDetail) {
      var unitWord = c.qty === 1 ? copy.unitOne : copy.unitMany;
      detailText = c.qty + ' ' + unitWord + ' · ' + formatSek(perUnit) + '/' + copy.perSuffix;
      sumDetail.textContent = detailText;
    }
    updateStickySummary(root, totalText, detailText);
    if (sumSave && sumHint) {
      if (savings.totalSaving > 0) {
        sumSave.hidden = false;
        sumHint.hidden = true;
        sumSave.textContent = 'Du sparar ' + formatSek(savings.totalSaving);
      } else {
        sumSave.hidden = true;
        sumHint.hidden = false;
        if (campaign.active) {
          sumHint.textContent =
            'Välj ' + campaign.minQty + '+ ' + copy.unitMany + ' för -' + campaign.percent + '% kampanj';
        }
      }
    }

    var isLastTier = index >= cards.length - 1 || c.qty >= maxTierQty;
    if (nudge && nudgeLead && nudgeProg && nudgeSave) {
      if (isLastTier) {
        nudge.hidden = true;
      } else {
        nudge.hidden = false;
        var next = cards[index + 1];
        var delta = next.price - c.price;
        var nextUnits = Math.max(next.qty - c.qty, 1);
        var addPhrase =
          copy.mode === 'cubic'
            ? nextUnits + ' ' + (nextUnits === 1 ? copy.unitOne : copy.unitMany)
            : '1 ' + (copy.unitOne || 'säck');
        nudgeLead.innerHTML =
          'Lägg till ' + addPhrase + ' till för <strong>' + formatSek(delta) + '</strong> mer';
        var pct = Math.min(100, Math.round((c.qty / maxTierQty) * 100));
        nudgeProg.style.width = pct + '%';
        var nextSavings = calculateCampaignSavings(next, campaign);
        var nextPer = nextSavings.finalPricePerUnit;
        nudgeSave.textContent =
          '→ Då sparar du ' +
          formatSek(nextSavings.totalSaving) +
          ' totalt och betalar bara ' +
          formatSek(nextPer) +
          '/' +
          copy.perSuffix;
      }
    }

    root.dataset.selectedVariantId = String(c.id);
  }

  function initMulti(root) {
    var cards = parseCards(root);
    if (!cards.length) return;

    var selectedEl = root.querySelector('.qty-card--selected');
    var startIdx = 0;
    if (selectedEl && !selectedEl.disabled) {
      var sid = parseInt(selectedEl.getAttribute('data-variant-id'), 10);
      startIdx = findIndex(cards, sid);
    }
    applySelection(root, cards, startIdx);

    cards.forEach(function (entry, i) {
      entry.el.addEventListener('click', function () {
        if (entry.el.disabled) return;
        applySelection(root, cards, i);
      });
    });

    var addBtn = root.querySelector('[data-purchase-add]');
    var stickyBtn = root.querySelector('[data-purchase-sticky-add]');
    setupStickyVisibility(root);
    if (addBtn && typeof window.CartStore !== 'undefined') {
      var origHtml = addBtn.innerHTML;
      var stickyOrigHtml = stickyBtn ? stickyBtn.innerHTML : '';
      var buttons = stickyBtn ? [addBtn, stickyBtn] : [addBtn];
      function setButtonsDisabled(disabled) {
        buttons.forEach(function (button) {
          button.disabled = disabled;
        });
      }
      function resetButtons() {
        addBtn.innerHTML = origHtml;
        if (stickyBtn) stickyBtn.innerHTML = stickyOrigHtml;
      }
      function addSelectedToCart() {
        var vid = parseInt(root.dataset.selectedVariantId, 10);
        if (!vid) return;
        var selectedCard = root.querySelector('.qty-card.qty-card--selected');
        var tierUnits = selectedCard ? parseInt(selectedCard.getAttribute('data-qty'), 10) : 1;
        if (!tierUnits || tierUnits < 1) tierUnits = 1;
        setButtonsDisabled(true);
        CartStore.addItem(vid, 1, { _tier_units: String(tierUnits) })
          .then(function () {
            if (window.CartDrawer && typeof CartDrawer.open === 'function') {
              CartDrawer.open();
            }
            addBtn.textContent = 'Tillagd!';
            if (stickyBtn) stickyBtn.textContent = 'Tillagd!';
            setTimeout(function () {
              setButtonsDisabled(false);
              resetButtons();
            }, 2000);
          })
          .catch(function () {
            setButtonsDisabled(false);
          });
      }
      addBtn.addEventListener('click', addSelectedToCart);
      if (stickyBtn) {
        stickyBtn.addEventListener('click', addSelectedToCart);
      }
    }
  }

  function boot() {
    document.querySelectorAll('[data-product-purchase][data-multi-tier="true"]').forEach(initMulti);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
